<template>
  <div>
    <Modal ref="modalRef">
      <template v-slot:header>
        <h2>Bekræft sletning</h2>
      </template>
      <template v-slot:body>
        <div v-if="this.modalContent">
          <p>Slet følgende fil loc?</p>
          {{ this.modalContent.displayName }}
          <div style="margin-top: 1rem" v-if="!showDeleting">
            <Button
              @click="deleteFile"
              style="display: inline !important; margin-right: 1rem"
              >OK</Button
            >
            <Button @click="closeModal" style="display: inline !important"
              >Annuller</Button
            >
          </div>
          <div v-else>
            Sletter fil...
            <img style="width: 20px" src="../../../assets/loading.gif" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, createNamespacedHelpers } from "vuex";
import Modal from "../../Modal.vue";
import Button from "../../Button.vue";
const location = createNamespacedHelpers("location");
const modal = createNamespacedHelpers("modal");
export default {
  name: "ModalDeleteFileConfirm",
  components: {
    Modal,
    Button,
  },
  computed: {
    ...mapGetters(["requestModalToBeOpened"]),
    ...modal.mapGetters(["modalContent"]),
  },
  data() {
    return {
      showDeleting: false,
    };
  },
  watch: {
    requestModalToBeOpened: function () {
      if (this.requestModalToBeOpened) {
        this.$refs.modalRef.toggleModal();
        this.$store.commit("REQUEST_MODAL_OPENED", false);
      }
    },
  },
  methods: {
    ...location.mapActions(["DELETE_LOCATION_FILES"]),
    closeModal: function () {
      this.$refs.modalRef.toggleModal();
    },
    deleteFile: function () {
      this.showDeleting = true;
      this.DELETE_LOCATION_FILES(this.modalContent).then(() => {
        this.showDeleting = false;
        this.$refs.modalRef.toggleModal();
        window.location.reload(); 
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.installation-files__item-icon {
  width: 1.1rem;
  position: absolute;
  left: 0;
  color: var(--color-red);

  &:hover {
    cursor: pointer;
  }
}
</style>
